/* eslint-disable no-bitwise */

export function uniqueId(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
}

export const pluralize = (count: number, noun: string, suffix = 's'): string =>
  `${noun}${count !== 1 ? suffix : ''}`;
